import { Factory } from '@octopus-do/octopus-project-core'

import { InitialColorIds } from '../colors'
import { InitialBlockIds } from './initialBlockIds'

export const initialBlocks = [
  Factory.block.monolithic({
    id: InitialBlockIds.header,
    title: 'Header',
    visual: {
      type: 'wireframes',
      wireframes: ['header'],
    },
    colorId: InitialColorIds.header,
  }),
  Factory.block.monolithic({
    id: InitialBlockIds.introduction,
    title: 'Introduction',
    visual: {
      type: 'wireframes',
      wireframes: ['text'],
    },
    colorId: InitialColorIds.default,
  }),
  Factory.block.monolithic({
    id: InitialBlockIds.services,
    type: 'monolithic',
    title: 'Services',
    visual: {
      type: 'wireframes',
      wireframes: ['double'],
    },
    colorId: InitialColorIds.default,
  }),
  Factory.block.monolithic({
    title: 'Latest News',
    visual: {
      type: 'wireframes',
      wireframes: ['text_triple'],
    },
    colorId: InitialColorIds.default,
    id: InitialBlockIds.news,
  }),
  Factory.block.monolithic({
    id: InitialBlockIds.footer,
    type: 'monolithic',
    title: 'Footer',
    visual: {
      type: 'wireframes',
      wireframes: ['footer'],
    },
    colorId: InitialColorIds.footer,
  }),
]
